import React from 'react';
import { StyledDetailTextWrapper, StyledDetailTextLabel, StyledDetailText } from './DeviceDetailsCard.style';
import { NOT_APPLICABLE } from '../../../constants/originalState';
export interface IDeviceDetailsCard {
  label: string,
  itemDetail?: any,
  locale: any,
}


const DeviceDetailsCard = (props: IDeviceDetailsCard) => {
  const { label, itemDetail, locale} = props;
  return (
    <StyledDetailTextWrapper>
      <StyledDetailTextLabel>{label}</StyledDetailTextLabel>
      <StyledDetailText>
        <div className="detailItem">
          <span className="label label-serial">{locale?.serial_number}: </span>
          <span>{itemDetail?.serial_number? itemDetail.serial_number : NOT_APPLICABLE}</span>
        </div>
        <div className="detailItem">
          <span className="label label-manufacturer">{locale?.manufacturer}: </span>
          <span>{itemDetail?.manufacturer? itemDetail.manufacturer : NOT_APPLICABLE}</span>
        </div>
        <div className="detailItem">
          <span className="label label-model">{locale?.model}: </span>
          <span>{itemDetail?.model? itemDetail.model : NOT_APPLICABLE}</span>
        </div>
      </StyledDetailText>
    </StyledDetailTextWrapper>
  )
}
export const defaultProps = {
  label: 'Label',
  locale: {
    serial_number: 'Serial Number',
    manufacturer: 'Manufacturer',
    model: 'Model Name',
  },
};
DeviceDetailsCard.defaultProps = defaultProps;

export default DeviceDetailsCard;